import { NgModule } from 'ng-metadata/core';
import { CheckoutPassportWizardComponent } from './passport-wizard.component';

@NgModule({
  declarations: [
    CheckoutPassportWizardComponent,
  ],
})
export class CheckoutPassportWizardModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/passport-wizard/passport-wizard.module.ts